<div class="streak-container">
  <div class="streak-header">
    <i class="fas fa-fire"></i>
    <span>{{streakNumber}} Tage in Folge</span>
  </div>
  
  <div class="widget">
    <div class="days-container">
      <div *ngFor="let day of days" class="day" [class.done]="day.active">
        <span>{{day.dayName}}</span>
        <i *ngIf="day.active" class="fas fa-fire"></i>
        <i *ngIf="!day.active" class="fas fa-circle"></i>
      </div>
    </div>
    <p>Lerne jeden Tag um den Streak am Laufen zu halten</p>
  </div>
</div>
